<div class="text-container">
  <h1>Downloading...</h1>
  <div class="text">Please wait we are downloading the form. This may take up to 30 seconds depending on the size of the form.
  </div>
</div>
